import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const NAC: React.FC = () => {
  const sections = [
    {
      title: 'Network Access Control (NAC)',
      content: 'Our NAC solutions provide comprehensive network access control and device compliance management, ensuring only authorized and compliant devices can access your network resources.',
      benefits: [
        'Device identification and profiling',
        'Policy-based access control',
        'Compliance assessment and remediation',
        'Guest network management',
        'Integration with existing security infrastructure'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="Network Access Control"
      subtitle="Advanced NAC solutions for comprehensive network access control and device compliance management."
      sections={sections}
    />
  );
};

export default NAC;

